import { useDispatch, useSelector } from 'react-redux'
import { SelectableUserAvatar } from './SelectableUserAvatar.jsx'
import { useEffect, useState } from 'react'
import { setSelectedUsers } from '../../features/schedulerSlice.js'
import styles from './timeLineStyle.module.scss'
import ProfileCard from '../../components/atoms/ProfileCard/ProfileCard.jsx'

export const TimeLineProfileFilters = () => {
	const dispatch = useDispatch()
	const bride = useSelector((state) => state.kazooEvent.kazooMembers.bride)
	const groom = useSelector((state) => state.kazooEvent.kazooMembers.groom)

	const [visibleUserProfiles, setVisibleUserProfiles] = useState([])

	useEffect(() => {
		// TODO: add logic if there are more members that have calendars here
		let users = [
			...(!bride?.status && bride?._id
				? [{ ...bride, selected: true }]
				: []),
			...(!groom?.status && groom?._id
				? [{ ...groom, selected: true }]
				: []),
		]

		// all possible selectable users (including guests)
		setVisibleUserProfiles([
			{
				id: 'guests',
				_id: 'guests',
				selected: false,
				preferredName: 'Guests',
			},
			...users,
		])

		users = users.map((user) => ({
			Id: user._id,
			OwnerText:
				user.preferredName || `${user.firstName} ${user.lastName}`,
		}))

		// currently selected users
		dispatch(setSelectedUsers(users))
	}, [dispatch, bride?._id, groom?._id])

	const toggleUserSelected = async (id) => {
		// TODO: add limit here
		let users = visibleUserProfiles.map((profile) => ({
			...profile,
			selected: profile._id === id ? !profile.selected : profile.selected,
		}))
		setVisibleUserProfiles(users)

		users = users
			.map((user) => ({
				Id: user._id,
				OwnerText:
					user.preferredName || `${user.firstName} ${user.lastName}`,
				selected: user.selected,
			}))
			.filter((user) => user.selected)
		dispatch(setSelectedUsers(users))
	}

	return (
		<div className={styles.selectableUserAvatarContainer}>
			{visibleUserProfiles.map((user) => {
				if (user._id)
					return (
						<SelectableUserAvatar
							key={user._id}
							selected={user.selected}
							userId={user._id}
							name={
								user.preferredName ||
								`${user.firstName} ${user.lastName}`
							}
							photoSrc={user.profilePic}
							updateToggled={toggleUserSelected}
						/>
					)
			})}
			{/* TODO: implemnt logic for adding others */}
			{/* <ProfileCard label="+ Add Others" onClick={() => alert('Add others clicked')} /> */}
		</div>
	)
}
